import { useQuery } from '@tanstack/react-query';
import { usersApi } from '../api/users';
import { UserDropdownDto } from '../types';

export function useUsers(brgId?: number) {
  return useQuery<UserDropdownDto[], Error>({
    queryKey: brgId ? ['users', 'brg', brgId] : ['users'],
    queryFn: () => usersApi.list(brgId),
  });
}
